// src/services/socketService.js
import io from 'socket.io-client';
import config from '../config';  // Asegúrate de tener configurado tu archivo config

let socket = null;

export const initializeSocket = (token) => {
  if (!socket) {
    socket = io(config.API_BASE_URL || 'http://localhost:3000', {
      transports: ['websocket'],
      auth: {
        token
      },
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000
    });

    socket.on('connect', () => {
      console.log('Conectado a Socket.IO:', socket.id);
    });

    socket.on('connect_error', (error) => {
      console.error('Error de conexión Socket.IO:', error);
    });

    socket.on('disconnect', (reason) => {
      console.log('Desconectado de Socket.IO:', reason);
    });
  }
  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

const socketService = {
  initializeSocket,
  getSocket,
  disconnectSocket
};

export default socketService;